import React from 'react';
interface TimeProps {
  icon: string;
  text: string;
  heading: string;
}

function Time({ icon, text, heading }: TimeProps) {
  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={icon}
        alt="icon"
        className="h-10 w-10 md:h-14 md:w-14"
        decoding="async"
        loading="lazy"
      />
      <div className="font-poppins py-4 text-sm font-medium text-textColor md:text-xl">
        {heading}
      </div>
      <div className="font-poppins text-center text-xs font-medium text-textColor md:w-[230px] md:text-xs">
        {text}
      </div>
    </div>
  );
}

export default Time;
